import React, { FunctionComponent, useEffect, useState } from 'react'
import { Button, Modal, notification, Space } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import { callApi, TApiResponse } from '../../../context/api'
import { Statuses, TExpert } from '../../../context/types'
import SpinLoader from '../../helpers/SpinLoader'
import Paragraph from 'antd/es/typography/Paragraph'

interface AdminReportProps {
	isVisible: boolean
	onChange: (value: boolean) => void
	forceUpdate?: () => void
	expert: TExpert
}

const AdminReportModal: FunctionComponent<AdminReportProps> = (props) => {
	const { isVisible, onChange, expert } = props

	const [loading, setLoading] = useState<boolean>(false)
	const [quarantineReason, setQuarantineReason] = useState<string>('')
	const [cloneExpert, setCloneExpert] = useState<TExpert>(expert)

	useEffect(() => {
		setCloneExpert(expert)
	}, [expert])
	const fetchUpdateProfile = async () => {
		if (!quarantineReason) {
			notification.error({ message: 'The quarantine reason is required!' })
			return
		}

		setLoading(true)

		try {
			cloneExpert.profile.status = Statuses.QUARANTINED
			const updateProfilesResponse: TApiResponse = await callApi('admin/expert/profiles', {
				method: 'PUT',
				body: {
					experts: [cloneExpert],
					quarantine_reason: quarantineReason,
				},
			})

			const { data } = updateProfilesResponse.payload

			if (updateProfilesResponse.ok) {
				notification.success({ message: 'Profile status was updated' })
				setQuarantineReason('')
				onChange(false)
			} else {
				throw new Error(data.message || 'Cannot update profile status!')
			}
		} catch (e) {
			notification.error({ message: e.message })
		}

		setLoading(false)
	}
	const handleCancel = () => {
		onChange(false)
	}

	if (!expert) {
		return <></>
	}

	return (
		<Modal
			title="Admin report"
			visible={isVisible}
			onOk={fetchUpdateProfile}
			onCancel={handleCancel}
			footer={[
				<Button key="back" onClick={handleCancel}>
					Cancel
				</Button>,
				<Button key="submit" type="primary" disabled={loading} onClick={fetchUpdateProfile}>
					Quarantined By Admin
				</Button>,
			]}
		>
			<SpinLoader loading={loading}>
				<Space direction={'vertical'}>
					<Paragraph>Please let the expert know why their profile is being placed in quarantine status</Paragraph>
					<TextArea
						placeholder="Quarantine reason"
						value={quarantineReason}
						onChange={(e) => setQuarantineReason(e.target.value)}
					></TextArea>
				</Space>
			</SpinLoader>
		</Modal>
	)
}

export default AdminReportModal
